import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { ValidationStatus } from '../../Core/Web/Validation/ValidationStatus';
import { InvestmentPathwayAnswers } from '../../Models/Domains/Account/InvestmentPathwayAnswers';
import { DrawdownInvestmentStrategy } from '../../Models/Domains/Account/DrawdownInvestmentStrategy';

declare var IS_RUNNING_IN_APP_POOL;

export class DrawdownInvestmentStrategyClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public post(subAccountHierarchyId: string, investmentPathwayAnswers: InvestmentPathwayAnswers): Promise<ValidationStatus, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Account/DrawdownInvestmentStrategy/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { subAccountHierarchyId: subAccountHierarchyId, investmentPathwayAnswers: investmentPathwayAnswers }

    return AjaxWrapper.post<ValidationStatus, any>(url, data);
  }
  public get(subAccountHierarchyId: string): Promise<DrawdownInvestmentStrategy, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Account/DrawdownInvestmentStrategy/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { subAccountHierarchyId: subAccountHierarchyId }

    return AjaxWrapper.get<DrawdownInvestmentStrategy, any>(url, data);
  }
}

